import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessGestionCampana } from '../utils/gestionCampanaAccess'

/**
 * Envuelve <Layout /> (u otro children) para rutas de Gestión Campaña.
 * Quien no sea administrador ni esté en la lista extra de ids → /inicio.
 */
const RequireGestionCampanaAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessGestionCampana(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireGestionCampanaAccess
